const initLightBoxGallery = () => {
    // Check if lightGallery is available (from CDN)
    if (typeof window.lightGallery !== 'undefined') {
        // Find the parent gallery container (not individual links)
        const galleryContainer = document.querySelector('.ImageGallery');
        
        if (galleryContainer && !galleryContainer.hasAttribute('data-lg-initialized')) {
            // Check if there are any gallery items
            const galleryItems = galleryContainer.querySelectorAll('[data-lightbox="gallery"]');
            
            if (galleryItems.length > 0) {
                // Initialize lightGallery on the parent container
                window.lightGallery(galleryContainer, {
                    selector: '[data-lightbox="gallery"]',
                    speed: 500,
                    download: true,
                    loop: true,
                    escKey: true,
                    keyPress: true,
                    // Thumbnail settings
                    thumbnail: true,
                    showThumbByDefault: true,
                    animateThumb: true,
                    thumbWidth: 100,
                    thumbHeight: 80,
                    thumbMargin: 5,
                    // Zoom settings
                    zoom: true,
                    actualSize: true,
                    // Fullscreen
                    fullScreen: true,
                    // General settings
                    mode: 'lg-slide',
                    cssEase: 'ease',
                    easing: 'ease',
                    enableSwipe: true,
                    enableDrag: true,
                    autoplay: false,
                    progressBar: true,
                    closable: true,
                    controls: true,
                    mousewheel: true,
                    getCaptionFromTitleOrAlt: true,
                    backdropDuration: 150,
                    hideBarsDelay: 6000,
                    showCloseIcon: true,
                    showMaximizeIcon: true,
                    counter: true
                });
                
                galleryContainer.setAttribute('data-lg-initialized', 'true');
            }
        }
    } else {
        // Retry after a short delay in case script hasn't loaded yet
        setTimeout(() => {
            if (typeof window.lightGallery !== 'undefined') {
                initLightBoxGallery();
            } else {
                console.error('lightGallery failed to load. Please check that the lightGallery CSS and JS files are properly enqueued.');
            }
        }, 100);
    }
}

export {initLightBoxGallery}
